import jwt_decode from 'jwt-decode'

export const decode = token => {
  if (!token) return null

  let jwtDecoded

  try {
    jwtDecoded = jwt_decode(token)
  } catch (error) {
    jwtDecoded = null
  }

  return jwtDecoded
}



// WEBPACK FOOTER //
// ./src/utils/safeJWTDecode.js